import { Injectable } from '@angular/core';
import { BreakpointObserver } from '@angular/cdk/layout';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { IconType } from 'src/app/shared/interface/icon.interface';
import { NavigationEnd, Router, Event } from '@angular/router';

export interface TitleToolbar {
  iconName: string;
  iconType: IconType;
  text: string;
}

@Injectable({
  providedIn: 'root'
})
export class LayoutService {
  private currentRoute$ = new BehaviorSubject<boolean>(this.getCurrentRoute());
  private taskRoute$ = new BehaviorSubject<boolean>(this.getTaskRoute());

  private _sidenavCollapsedSubject = new BehaviorSubject<boolean>(true);
  sidenavCollapsed$ = this._sidenavCollapsedSubject.asObservable();
  public _pageTitle: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public readonly titleToolbar$: Observable<any> = this._pageTitle.asObservable();
  isScreenXXL$!: Observable<boolean>;
  isScreenXL$!: Observable<boolean>;
  isScreenLG$!: Observable<boolean>;
  isScreenMD$!: Observable<boolean>;
  isScreenSMD$!: Observable<boolean>;
  isScreenSM$!: Observable<boolean>;
  isScreenXS$!: Observable<boolean>;
  isScreenXXS$!: Observable<boolean>;

  constructor(
    private breakpointObserver: BreakpointObserver,
    private router: Router
  ) {
    this.isScreenXXL$ = this.breakpointObserver.observe(`(min-width: 1925px)`).pipe(map(state => state.matches));
    this.isScreenXL$ = this.breakpointObserver.observe(`(min-width: 1366px)`).pipe(map(state => state.matches));
    this.isScreenLG$ = this.breakpointObserver.observe(`(min-width: 1280px)`).pipe(map(state => state.matches));
    this.isScreenMD$ = this.breakpointObserver.observe(`(min-width: 960px)`).pipe(map(state => state.matches));
    this.isScreenSMD$ = this.breakpointObserver.observe(`(min-width: 768px)`).pipe(map(state => state.matches));
    this.isScreenSM$ = this.breakpointObserver.observe(`(min-width: 600px)`).pipe(map(state => state.matches));
    this.isScreenXS$ = this.breakpointObserver.observe(`(min-width: 460px)`).pipe(map(state => state.matches));
    this.isScreenXXS$ = this.breakpointObserver.observe(`(min-width: 400px)`).pipe(map(state => state.matches));
    
    this.router.events
      .pipe(
        filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd), // Type guard para NavigationEnd
        map((event: NavigationEnd) => event.urlAfterRedirects)
      )
      .subscribe(url => {
        const isMainDashboard = url.includes("tablero");
        const isTaskPage = url.includes("tareo");
        this.currentRoute$.next(isMainDashboard);
        this.taskRoute$.next(isTaskPage); 
      });
  }

  collapseSidenav() {
    this._sidenavCollapsedSubject.next(true);
  }

  expandSidenav() {
    this._sidenavCollapsedSubject.next(false);
  }

  setTitleInToolbar(newTitle: TitleToolbar | null) {
    this._pageTitle.next(newTitle);
  }

  public getCurrentRoute(): boolean {
    if (window.location.pathname.includes("tablero")) {
      return true;
    }
    return false;
  }

  public getTaskRoute(): boolean {
    if (window.location.pathname.includes("tareo")) {
      return true;
    }
    return false;
  }

  get currentRouteObservable() {
    return this.currentRoute$.asObservable();
  }

  get taskRouteObservable() {
    return this.taskRoute$.asObservable();
  }
}
